const t = {
  name: "CreditcardChip",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M22 17C22 19.7614 19.7614 22 17 22H7C4.23858 22 2 19.7614 2 17V7C2 4.23858 4.23858 2 7 2H17C19.7614 2 22 4.23858 22 7V17ZM7 4C5.34315 4 4 5.34315 4 7V8H11V4H7ZM13 11H20V7C20 5.34315 18.6569 4 17 4H13V11ZM20 13H13V20H17C18.6569 20 20 18.6569 20 17V13ZM11 10H4V14H11V10ZM11 16H4V17C4 18.6569 5.34315 20 7 20H11V16Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as CreditcardChip
};
